<template>
  <div class="mod-app-manage">
    <div class="title-page">
      <span class="text-title">我的应用</span>
      <a 
        v-if="!listData.list || !listData.list.length || listData.list.length < 200"
        class="item-btn"
        @click="showDialog(null)"
      >
        + 创建应用
      </a>
    </div>
    <div class="show-cards-box">
      <ShowCards 
        v-if="status === 1"
        :loading="loading"
        :listData="cardListData"
        :isEdit="true"
        noDataText="暂无应用"
        @edit="editHandle"
        @action="cardAction"
      />
      <div 
        v-else
        class="status-box"
      >
        <p class="status-text">审核中</p>
        <p class="status-desc">抱歉，您的信息正在审核中</p>
        <a 
          class="item-btn"
          @click="$router.push('home')"
        >
          返回首页
        </a>
      </div>
    </div>
    <el-dialog 
      :visible.sync="addDialogShow"
      :title="curItem ? curItem.name : '创建应用'" 
      width="538px"
      top="60px"
      :modal="false"
      :show-close="false"
      custom-class="dialog-right"
    >
      <div class="add-content-box">
        <ul 
          v-if="curItem" 
          class="app-items"
        >
          <li class="app-item">
            <div class="split-item">
              <label class="app-label">创建时间：</label>
              <span class="app-value">{{ curItem.create_time }}</span>
            </div>
            <div class="split-item">
              <label class="app-label">更新时间：</label>
              <span class="app-value">{{ curItem.update_time }}</span>
            </div>
          </li>
          <li class="app-item">
            <label class="app-label">应用ID：</label>
            <span class="app-value">{{ curItem.id }}</span>
          </li>
          <li 
            v-if="false" 
            class="app-item"
          >
            <label class="app-label">应用秘钥：</label>
            <span class="app-value">{{ secretShow ? curItem.secret : pwdString }}</span>
            <a 
              class="btn-item" 
              @click="secretShow=!secretShow"
            >
              {{ secretShow ? '隐藏' : '查看' }}
            </a>
          </li>
        </ul>
        <div class="add-form-box">
          <ShowForm
            ref="form"
            :formData="formData"
            :commitShow="false"
            label-width="120px"
            input-width="100%"
            @changeCheckbox="changeCheckbox"
            @action="formAction"
          />
        </div>
      </div>
      <div 
        slot="footer" 
        class="dialog-footer"
      >
        <el-button @click="addDialogShow = false">取 消</el-button>
        <el-button 
          type="primary" 
          @click="doEdit"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ShowCards from '@/components/ShowCards/index';
import ShowForm from '@/components/ShowForm/index';
import {
  getEnum,
  getAppList,
  getUserInfo,
  createApp,
  updateApp,
} from '@/service';
import { formatMap } from '@/assets/js/lib';

const AUTH_PATH = '/new/index.html#/mkt-api-auth-v2';

export default {
  components: {
    ShowCards,
    ShowForm,
  },
  data() {
    return {
      status: 1,
      loading: true,
      listData: {
        head: [
          {
            key: 'name',
            name: '应用名称',
            type: 'title',
          },
          {
            key: 'id',
            name: '应用ID',
          },
          {
            key: 'level',
            name: '应用等级',
          },
          {
            key: 'redirect_uri',
            name: '回调地址',
            hideWhenEmpty: true,
            tooltip: true,
          },
          {
            key: 'auth_url',
            name: '授权 URL',
            hideWhenEmpty: true,
            tooltip: true,
            appendActions: [
              {
                key: 'copy',
                icon: 'el-icon-document-copy',
                title: '复制授权 URL',
              },
              {
                key: 'open',
                icon: 'el-icon-link',
                title: '跳转授权 URL',
              },
            ],
          },
          {
            key: 'create_time',
            name: '创建时间',
          },
          {
            key: 'update_time',
            name: '更新时间',
          },
        ],
        list: [],
      },
      curItem: null,
      addDialogShow: false,
      secretShow: false,
      editFlag: false,
      isNew: 0,
      pwdString: '************************************************',
      formData: [],
      scopeType: [],
    };
  },
  computed: {
    isNewUser() {
      return this.isNew === 1;
    },
    cardListData() {
      return {
        ...this.listData,
        list: this.listData.list.map((item) => ({
          ...item,
          auth_url: item.redirect_uri ? this.getAuthUrl(item.id, item.redirect_uri) : '',
        })),
      };
    },
  },
  watch: {
    isNew() {
      if (!this.addDialogShow) return;
      const values = {};
      this.formData.forEach((item) => {
        values[item.key] = item.value;
      });
      this.formData = this.getFormData(this.curItem);
      this.formData.forEach((item) => {
        if (Object.prototype.hasOwnProperty.call(values, item.key)) {
          this.$set(item, 'value', values[item.key]);
        }
      });
    },
    formData: {
      deep: true,
      handler() {
        this.updateAuthUrl();
      },
    },
  },
  created() {
    this.getList();
    this.getScopeType();
    this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      try {
        const res = await getUserInfo(false);
        if (res && res.data) {
          this.isNew = res.data.is_new;
        }
      } catch (e) {
        // 用户信息加载失败时按旧用户处理，不展示新授权版本字段。
        this.isNew = 0;
      }
    },
    getAuthDomain() {
      return process.env.VUE_APP_ADV_HOST || window.location.origin;
    },
    getAuthUrl(appId, redirectUri) {
      if (appId === undefined || appId === null || appId === '') return '';
      return `${this.getAuthDomain()}${AUTH_PATH}?app_id=${encodeURIComponent(
        appId,
      )}&redirect_uri=${encodeURIComponent(redirectUri || '')}`;
    },
    updateAuthUrl() {
      if (!this.isNewUser || !this.curItem) return;
      const redirectItem = this.formData.find((item) => item.key === 'redirect_uri');
      const authItem = this.formData.find((item) => item.key === 'auth_url');
      if (!redirectItem || !authItem) return;
      const value = this.getAuthUrl(this.curItem.id, redirectItem.value);
      if (authItem.value !== value) this.$set(authItem, 'value', value);
    },
    copyAuthUrl(item) {
      if (!item.value || !this.$copyText) return;
      Promise.resolve(this.$copyText(item.value)).then(
        () => {
          this.$message.success('已复制到粘贴板');
        },
        () => {
          this.$message.error('当前浏览器不支持复制');
        },
      );
    },
    openAuthUrl(item) {
      if (item.value) window.open(item.value);
    },
    formAction(item, btn) {
      if (btn.key === 'copy') {
        this.copyAuthUrl(item);
      } else if (btn.key === 'open') {
        this.openAuthUrl(item);
      }
    },
    cardAction(item, head, btn) {
      this.formAction({ value: item[head.key] }, btn);
    },
    changeCheckbox(item) {
      // 如权限选择agent或sub_agent，去掉勾选项ads_read、ads_write、dmp并禁用
      if (['agent', 'sub_agent'].some((x) => item.value.includes(x))) {
        item.value = item.value.filter(
          (x) => x !== 'ads_read' && x !== 'ads_write' && x !== 'dmp',
        );
        item.options.forEach((x) => {
          if (['ads_read', 'ads_write', 'dmp'].includes(x.key)) {
            this.$set(x, 'disabled', true);
          }
        });
      } else {
        item.options.forEach((x) => {
          if (this.editFlag && ['agent', 'sub_agent'].includes(x.key)) {
            this.$set(x, 'disabled', true);
          } else {
            this.$set(x, 'disabled', false);
          }
        });
      }
      this.$forceUpdate();
    },
    async getScopeType() {
      const res = await getEnum({
        enum_type: 'client_scopes',
      });
      const options = formatMap(res.data) || [];
      const descs = {
        ads_read: '对ADV广告主账户信息，投放管理，数据报表有读取权限',
        ads_write: '对ADV广告主账户投放管理有增加和修改权限',
        dmp: '对ADV广告主账户的DMP有管理权限',
        agent: '有代理商服务权限，勾选后应用只可绑定代理商账号',
        sub_agent: '有子管理服务权限，勾选后应用只可绑定子管理账号',
      };
      options.forEach((item) => {
        item.desc = descs[item.key];
      });
      this.scopeType = options;
    },
    async getList() {
      const res = await getAppList({});
      this.$set(this.listData, 'list', res.data || []);
      this.loading = false;
    },
    async doCreate(val) {
      const res = await createApp(val);
      const msgType = (res && res.code === 200) ? 'success' : 'error';
      this.$message({
        message: res.message,
        type: msgType,
        showClose: true,
        duration: 3000,
      });
      this.addDialogShow = false;
      this.getList();
    },
    async doUpdate(val) {
      const res = await updateApp(val);
      const msgType = (res && res.code === 200) ? 'success' : 'error';
      this.$message({
        message: res.message,
        type: msgType,
        showClose: true,
        duration: 3000,
      });
      this.addDialogShow = false;
      this.getList();
    },
    getFormData(val) {
      const formData = [
        {
          key: 'description',
          name: '备注：',
          type: 'textarea',
          placeholder:
            '用于备注您新建应用的所需功能和使用场景，字数不超过100字',
          maxLength: 100,
          showWordLimit: 1,
        },
      ];
      if (this.isNewUser) {
        formData.push({
          key: 'redirect_uri',
          name: '回调地址',
          labelSuffix: '：',
          labelTip:
            '回调地址是一个用户自定义的链接地址，用户授权完成后，Marketing-API会将授权相关的信息和state作为参数拼接至该回调地址，并进行跳转。',
          required: true,
          placeholder: '请输入授权完成后的回调地址',
        });
      }
      if (val && this.isNewUser) {
        formData.push({
          key: 'auth_url',
          name: '授权 URL：',
          readonly: true,
          submit: false,
          value: this.getAuthUrl(val.id, val.redirect_uri),
          appendActions: [
            {
              key: 'copy',
              name: '复制',
              title: '复制授权 URL',
            },
            {
              key: 'open',
              name: '跳转',
            },
          ],
        });
      }
      formData.push({
        key: 'scopes',
        name: '权限选择：',
        type: 'checkbox',
        uniline: true,
        required: true,
        value: [],
        options: this.scopeType,
      });
      if (val) {
        formData.forEach((item) => {
          if (Object.prototype.hasOwnProperty.call(val, item.key)) {
            this.$set(item, 'value', val[item.key]);
          }
        });
        return formData;
      }
      return [
        {
          key: 'name',
          name: '应用名称：',
          required: true,
          placeholder: '请输入真实的应用名称，且多个应用程序名称不允许重复',
          maxLength: 20,
          showWordLimit: 1,
        },
      ].concat(formData);
    },
    showDialog(item) {
      this.curItem = item;
      this.formData = this.getFormData(this.curItem);
      this.addDialogShow = true;

      // 默认创建: 去掉权限勾选禁用
      this.editFlag = false; // 添加进入
      if (!item) {
        let index = this.formData.findIndex((x) => x.key === 'scopes');
        this.formData[index].options.forEach((x) => {
          this.$set(x, 'disabled', false);
        });
      }
    },
    doEdit() {
      let val = this.$refs.form.getValue();
      let action = 'doCreate';
      if (this.curItem) {
        action = 'doUpdate';
        val.id = this.curItem.id;
      }
      if (!val.scopes || !val.scopes.length) {
        this.$message({
          message: '请选择权限',
          type: 'error',
          showClose: true,
          duration: 3000,
        });
        return;
      }
      if (this.isNewUser && (!val.redirect_uri || !val.redirect_uri.trim())) {
        this.$message({
          message: '请输入回调地址',
          type: 'error',
          showClose: true,
          duration: 3000,
        });
        return;
      }
      this[action](val);
    },
    editHandle(item) {
      this.formData = this.getFormData(item);
      this.showDialog(item);

      this.editFlag = true; // 编辑进入
      if (['agent', 'sub_agent'].some((x) => item.scopes.includes(x))) {
        // 编辑: 权限选择agent或sub_agent，去掉勾选项ads_read、ads_write、dmp并禁用
        let index = this.formData.findIndex((x) => x.key === 'scopes');
        this.$set(
          this.formData[index],
          'value',
          item.scopes.filter(
            (x) => x !== 'ads_read' && x !== 'ads_write' && x !== 'dmp',
          ),
        );
        this.formData[index].options.forEach((x) => {
          this.$set(x, 'disabled', true);
        });
      } else {
        // 编辑: 权限不选择agent或sub_agent，去掉禁用
        let index = this.formData.findIndex((x) => x.key === 'scopes');
        this.$set(this.formData[index], 'value', item.scopes);
        this.formData[index].options.forEach((x) => {
          if (['agent', 'sub_agent'].includes(x.key)) {
            this.$set(x, 'disabled', true);
          } else {
            this.$set(x, 'disabled', false);
          }
        });
      }
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
.mod-app-manage {
  height: 100%;
  overflow-y: auto;
  .item-btn {
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    background: $primary-color;
    box-shadow: 0px 2px 4px 0px rgba(0, 94, 181, 0.19);
    border-radius: 4px;
    text-align: center;
    font-size: 14px;
    font-family: NotoSansHans-Bold, NotoSansHans;
    font-weight: bold;
    color: #fff;
  }
  .title-page {
    display: flex;
    justify-content: space-between;
    padding: 40px 74px 0;
    .text-title {
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
    }
  }
  .show-cards-box {
    padding: 15px 68px 40px;
    box-sizing: border-box;
    .status-box {
      padding-top: 235px;
      text-align: center;
      .status-text {
        font-size: 30px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 42px;
        color: #e6a23c;
      }
      .status-desc {
        margin-top: 10px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #c0c4cc;
      }
      .item-btn {
        width: 100px;
        margin-top: 30px;
      }
    }
  }
  .add-content-box {
    padding: 14px 0;
    .app-items {
      padding: 0 22px;
      .app-item {
        display: flex;
        align-items: flex-start;
        padding: 11px 0;
        border-bottom: 1px solid #f2f2f2;
        font-size: 14px;
        font-weight: 400;
        font-family: PingFangSC-Regular, PingFang SC;
        .split-item {
          flex-grow: 1;
        }
        .app-label {
          flex-shrink: 0;
          display: inline-block;
          width: 78px;
          text-align: right;
          color: #666666;
          .app-label-tip {
            padding-top: 6px;
            font-size: 12px;
            .active {
              color: $primary-color;
            }
          }
        }
        .app-value {
          flex-grow: 1;
          color: #333333;
        }
        .btn-item {
          flex-shrink: 0;
          margin-left: 13px;
          font-size: 12px;
          font-weight: 500;
          color: $primary-color;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
    .add-form-box {
      padding: 13px 10px;
    }
  }
}
</style>
